import { useCallback } from 'react'

import { useRouter } from 'next/router'

const useResetQueryStrings = () => {
  const router = useRouter()

  const resetQueryStrings = useCallback(
    (queryStrings: string[]) => {
      const query = { ...router.query }

      queryStrings.forEach(key => {
        delete query[key]
      })

      if (Object.keys(query).length !== Object.keys(router.query).length) {
        router.push({ query: Object.keys(query).length ? query : null }, undefined, { shallow: true })
      }
    },
    [router],
  )

  return resetQueryStrings
}

export default useResetQueryStrings
